angular
    .module("skillBuilderSaaS")
    .directive("updateLanguage", (["$rootScope", function ($rootScope) {
        return {
            link: function () {
                var listener = function (_event, translationResp) {
                    var defaultLang = "en", currentLang = translationResp.language;
                    angular.element("html").attr("lang", currentLang || defaultLang);
                    //element.attr("lang", currentLang || defaultLang);
                };
                $rootScope.$on("$translateChangeSuccess", listener);
            }
        };
    }]));
